module.exports = "textarea {\n    resize: vertical;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/client/payReceipt/payReceipt.component.css
 ** module id = 1010
 ** module chunks = 0
 **/